export const INVITATION_CREATE_REQUESTED = 'INVITATION_CREATE_REQUESTED';
export const INVITATION_CREATE_SUCCEED = 'INVITATION_CREATE_SUCCEED';
export const INVITATION_CREATE_FAILED = 'INVITATION_CREATE_FAILED';

export const INVITATION_RESET_STATE = 'INVITATION_RESET_STATE';
